<app-header></app-header>

<!-- ========== MAIN CONTENT ========== -->
<div id="feedback_screen" role="main" class="main">
  <!-- Content -->
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col">
        <div class="feedback_wrapper">
          <h1 class="display-6 fw-bold mb-3">
            {{ errorMsg.heading }}
          </h1>
          <h3>{{ errorMsg.message }}</h3>

          <!-- <div class="powered_by text-center mt-6" *ngIf="!isExternal">
            <p>
              Powered by
              <img
                class="img-fluid w-10 ms-2"
                src="assets/images/powered_by.svg"
                alt="Powered by logo"
              />
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- END Content -->
</div>
